<div [ngClass]="notification.type"
     role="alert"
     class="notification-container">
  {{notification.content}}

  <div *ngIf="notification.clearable" class="notification-action">
    <button (click)="activated.emit()" mat-button>{{notification.actionCaption}}</button>
  </div>
</div>
